module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.85b9ca7.woff";